<template>
  <transition name="slide-fade-top">
    <div class="individuals-header" v-if="load" :class="`individuals-header-${el}`">
      <div class="el-and-text">
        <Chemical v-if="load" :el="el" :large="true" />
        <div class="titles">
          <h3 class="text-light">{{ $t(`products-${el}-title-1`) }}</h3>
          <h1 class="text-light">{{ $t(`products-${el}-title-2`) }}</h1>
        </div>
      </div>
      <div class="scrollers-wrapper" :class="{ 'scrollers-wrapper-closed': !scrollersActive }">
        <div class="scrollers-dot" :class="{ 'scrollers-dot-hidden': scrollersActive }"></div>
        <div class="scrollers" :class="`scrollers-${el}`">
          <div class="scrollers-toggle" :class="{ 'scrollers-toggle-inactive': !scrollersActive }">
            <div class="scrollers-circle">{{el}}</div>
            <span class="text-light">{{ $t('parameters') }}</span>
          </div>
          <div
            class="scrollers-toggle"
            @click="scrollTo('alloysElement')"
            :class="{ 'scrollers-toggle-inactive': !scrollersActive }"
          >
            <div class="scrollers-circle">
              <span class="kcm">X</span>
            </div>
            <span class="text-light">{{ $t('alloys') }}</span>
          </div>
          <div
            class="scrollers-toggle"
            @click="scrollTo('docsElement')"
            :class="{ 'scrollers-toggle-inactive': !scrollersActive }"
          >
            <div class="scrollers-circle">
              <span class="kcm">Y</span>
            </div>
            <span class="text-light">{{ $t('documents') }}</span>
          </div>
          <div
            class="scrollers-toggle"
            @click="scrollTo('factsElement')"
            :class="{ 'scrollers-toggle-inactive': !scrollersActive }"
          >
            <div class="scrollers-circle">
              <span class="kcm">W</span>
            </div>
            <span class="text-light">{{ $t('facts') }}</span>
          </div>
          <div
            class="scrollers-toggle"
            @click="scrollTo('footerInquiryForm')"
            :class="{ 'scrollers-toggle-inactive': !scrollersActive }"
          >
            <div class="scrollers-circle">
              <span class="kcm">V</span>
            </div>
            <span class="text-light">{{ $t('inquiry') }}</span>
          </div>
        </div>
        <div class="scrollers-dot" :class="{ 'scrollers-dot-hidden': scrollersActive }"></div>
      </div>
    </div>
  </transition>
</template>

<script>
import Chemical from "./Chemical";
export default {
  props: ["el"],
  components: {
    Chemical
  },
  data() {
    return {
      load: false,
      scrollersActive: false
    };
  },
  methods: {
    scroll(el) {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      window.scrollTo({
        top: el.getBoundingClientRect().top + scrollTop - 100,
        behavior: "smooth"
      });
    },
    scrollTo(id) {
      const target = document.getElementById(id);
      if (target) {
        this.scroll(target);
        setTimeout(() => {
          this.scroll(target);
        }, 1000);
      }
    },
    handleClick(e) {
      if (
        e.target.matches(".scrollers-wrapper") ||
        e.target.matches(".scrollers-dot") ||
        e.target.matches(".scrollers")
      ) {
        this.scrollersActive = true;
      } else {
        this.scrollersActive = false;
      }
    }
  },
  mounted() {
    this.load = true;
    document.addEventListener("click", this.handleClick);
  },
  destroyed() {
    document.removeEventListener("click", this.handleClick);
  }
};
</script>

<style lang="scss" scoped>
.individuals-header {
  @extend %flex-center;
  justify-content: space-between;
  height: 160px;
  padding: 0 $sidesPadding;
  .el-and-text {
    @extend %flex-center;
    .el {
      @include transform(translateY(25%));
      margin: 0;
      margin-right: $sidesPadding / 2;
    }
    h1 {
      font-size: 42px;
    }
  }
  .scrollers {
    display: flex;
  }
  .scrollers-toggle {
    @extend %flex-center;
    cursor: pointer;
    flex-direction: column;
    // margin-left: 10px;
    .scrollers-circle {
      @extend %flex-center;
      background-color: $mainTextLight;
      border-radius: 50%;
      border: 3px solid rgba(255, 255, 255, 0.2);
      color: $mainText;
      font-size: 20px;
      font-weight: 500;
      height: 60px;
      margin: 0 10px;
      position: relative;
      text-transform: capitalize;
      @include transition(all 0.3s $mainCubic);
      width: 60px;
      .kcm {
        font-size: 26px;
      }
    }
    .scrollers-circle::before {
      background-color: rgba(255, 255, 255, 0.2);
      border-radius: 50%;
      content: "";
      height: 125%;
      left: -12.5%;
      position: absolute;
      top: -12.5%;
      @include transition(all 0.6s $mainCubic);
      width: 125%;
    }
    > span {
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      margin-top: 10px;
    }
  }
  .scrollers-toggle:hover {
    .scrollers-circle::before {
      height: 100%;
      left: 0;
      top: 0;
      width: 100%;
    }
  }
}
.individuals-header-zn {
  background-color: $znDark;
}
.individuals-header-pb {
  background-color: $pbDark;
}
.individuals-header-au {
  background-color: $auDark;
}
.individuals-header-ag {
  background-color: $agDark;
}
.individuals-header-ch {
  background-color: #4168b1;
}
@media screen and (max-width: 1600px) {
  .individuals-header {
    padding: 0 $sidesPadding1600;
    .el-and-text {
      .el {
        margin-right: $sidesPadding1600 / 2;
      }
      h1 {
        font-size: 42px;
      }
    }
  }
}
@media screen and (max-width: 1440px) {
  .individuals-header {
    .scrollers-toggle {
      .scrollers-circle {
        font-size: 18px;
        height: 50px;
        width: 50px;
        .kcm {
          font-size: 18px;
        }
      }
      > span {
        font-size: 9px;
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .individuals-header {
    height: 120px;
    padding: 0 $sidesPadding1280;
    .el-and-text {
      .el {
        margin-right: $sidesPadding1280 / 2;
      }
      h1 {
        font-size: 32px;
      }
    }
    .scrollers-toggle {
      .scrollers-circle {
        font-size: 16px;
        height: 40px;
        width: 40px;
        .kcm {
          font-size: 18px;
        }
      }
      > span {
        font-size: 8px;
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .individuals-header {
    padding-right: 100px;
    position: relative;
    z-index: 1;
    .el-and-text {
      h1 {
        font-size: 24px;
      }
      h3 {
        font-size: 10px;
      }
    }
    .scrollers-wrapper {
      border-radius: 30px;
      border: 2px solid #fff;
      align-items: center;
      // background-color: red;
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      overflow: hidden;
      right: 20px;
      @include transform(translateY(-50%));
      @include transition(all 1s $mainCubic);
      top: 50%;
      width: 60px;
      z-index: 1;
    }
    .scrollers {
      background-color: $mainColor;
      border-radius: 0;
      padding: 10px 0;
      flex-direction: column;
      @include transition(all 1s $mainCubic);
      min-height: 7px;
      min-width: 7px;
      .scrollers-toggle {
        height: 60px;
        overflow: hidden;
        @include transition(all 1s $mainCubic);
        width: 60px;
        > span {
          margin-top: 5px;
        }
      }
      .scrollers-toggle-inactive {
        height: 0;
        opacity: 0;
        width: 0;
      }
    }
    // .scrollers
    .scrollers-zn {
      background-color: $znDark;
    }
    .scrollers-pb {
      background-color: $pbDark;
    }
    .scrollers-au {
      background-color: $auDark;
    }
    .scrollers-ag {
      background-color: $agDark;
    }
    .scrollers-ch {
      background-color: #4168b1;
    }
    .scrollers-dot {
      background-color: #fff;
      border-radius: 50%;
      height: 7px;
      margin: 3px 0;
      @include transition(all 1s $mainCubic);
      width: 7px;
    }
    .scrollers-dot-hidden {
      width: 0;
      height: 0;
      margin: 0;
      opacity: 0;
    }
    .scrollers-wrapper-closed {
      background-color: transparent;
      border-radius: 50%;
      border-color: transparent;
      .scrollers {
        background-color: #fff;
        border-radius: 50%;
        padding: 0;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .individuals-header {
    height: 80px;
    padding: 0 $sidesPadding600;
    padding-right: 80px;
    .el-and-text {
      h1 {
        font-size: 20px;
        line-height: 20px;
      }
      h3 {
        font-size: 8px;
      }
    }
    .scrollers-wrapper {
      right: 10px;
    }
  }
}
@media screen and (max-width: 420px) {
  .individuals-header {
    .el-and-text {
      h1 {
        font-size: 16px;
        line-height: 16px;
      }
      h3 {
        font-size: 8px;
      }
    }
  }
}
</style>
